import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { UsersService } from '../../../services/users/users.service';
import { ResourceService } from '../../../services/resource/resource.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TokenStorage } from 'src/app/auth/token.storage';


@Component({
  selector: 'app-adduser',
  templateUrl: './adduser.component.html',
  styleUrls: ['./adduser.component.scss']
})
export class AdduserComponent implements OnInit {

  userForm: FormGroup;
  submitText: string;
  activityCreatedLog = [];
  activityUpdatedLog = [];
  allresources = [];
  allresourcesArray = [];
  allBranchesNames = [];
  resourceArray = [];
  isResource: boolean = false;
  isAssociatedUnit: boolean = false;
  isDriver: boolean = false;
  isTenantDiag: boolean = false;
  allRoles = [];
  config = {
    search: true,
    displayKey: 'driverName',
    searchOnKey: 'driverName',
    height: '40vh',
    placeholder: 'Select Resource'
  }

  configbranchNameAndArea = {
    search: true,
    displayKey: 'branchNameAndArea',
    searchOnKey: 'branchNameAndArea',
    height: '40vh',
    placeholder: 'Select Associated Unit'
  }

  constructor(
    public formBuilder: FormBuilder,
    public snackBar: MatSnackBar,
    public userService: UsersService,
    public resourceService: ResourceService,
    public router: Router,
    private datePipe: DatePipe,
    private token: TokenStorage,

  ) {
    if (this.token.getCustomerType() === 'Diagnostic') {
      this.isTenantDiag = true;
    }
    else {
      this.isTenantDiag = false;
    }

    this.createUserForm();
    this.submitText = "Submit";

  }

  createUserForm() {
    this.userForm = this.formBuilder.group({
      'firstName': [null, [
        Validators.required,
        Validators.pattern("^[a-zA-Z_ ]+$")
      ]],
      'lastName': [null, [
        Validators.pattern("^[a-zA-Z_ ]+$")
      ]],
      'gender': [null],
      'phoneNumber1': [null, [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(10),
        Validators.pattern('^[0-9]*$')
      ]],
      'emailId': [null, Validators.email
      ],
      'dateOfBirth': [null],
      'governmentIdType1': [null],
      'governmentIdNumber1': [null, [Validators.pattern("^[a-zA-Z0-9_ ]+$")]],
      'resourceType': [null],
      'designation': [null],
      'language': [null],
      'branchNames': [null, [
        Validators.required]],
      'roles': [null, [
        Validators.required]],
      'username': [null, [
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9_@]+$")
      ]],
      'password': [null, [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(20),
      ]],
    });
  }

  openSnackBar(message) {
    this.snackBar.open(message, 'X', {
      duration: 2000,
    });
  }

  ngOnInit() {
    this.userService.getAllRoles().subscribe(roles => {
      this.allRoles = roles;
    })
    //this.getAllUsers();
    this.resourceService.getAllResources().subscribe(allresources => {
      console.log("allresources", allresources);
      this.resourceArray = [];
      this.allresources = allresources;
      allresources.forEach(driver => {
        let driverName, resourceId = {};
        if (driver.lastName && driver.firstName)
          driverName = driver.firstName + " " + driver.lastName;
        else
          driverName = driver.firstName;
        this.resourceArray.push({
          driverName: driverName,
          resourceId: driver.resourceId
        });
      });
      this.resourceArray.sort(function (a, b) {
        let resourceName1 = a.driverName.toLowerCase(), resourceName2 = b.driverName.toLowerCase()
        if (resourceName1 < resourceName2) //sort string ascending
          return -1
        if (resourceName1 > resourceName2)
          return 1
        return 0
      });
    });

    this.resourceService.getBranches().subscribe(allBranches => {
      console.log("branches", allBranches);
      this.allBranchesNames = allBranches;

      this.allBranchesNames.sort(function (a, b) {
        let branchArea1 = a.branchName.toLowerCase(), branchArea2 = b.branchName.toLowerCase()
        if (branchArea1 < branchArea2)
          return -1
        if (branchArea1 > branchArea2)
          return 1
        return 0
      });

    });
  }

  getAllUsers() {
    this.userService.getAllUsers().subscribe(res => {
      console.log(res);
      for (let i = 0; i < 1; i++) {
        if (res[i]) {
          this.activityCreatedLog.push({
            username: res[i].username,
            createdBy: res[i].updatedByusername,
            creadtedDate: this.datePipe.transform(res[i].creationDateTime, 'yyyy-MM-dd'),
            creadtedTime: res[i].creationDateTime,
          });
          this.activityUpdatedLog.push({
            userName: res[i].username,
            updatedBy: res[i].updatedByusername,
            updatedDate: this.datePipe.transform(res[i].updatedDateTime, 'yyyy-MM-dd'),
            updatedTime: res[i].updatedDateTime
          });
          console.log(this.activityUpdatedLog);
        }
      }
    }, Error => {
      console.log(Error);
    });


  }

  onSelectResource(resource) {
    this.isResource = true;
    if (resource === 'driver')
      this.isDriver = true;
    else
      this.isDriver = false;
  }

  onSelectAssociatedUnit() {
    this.isAssociatedUnit = true;
  }

  selectBirthDate(event) {
    let date = new Date(event.value);
    console.log(this.datePipe.transform(date, 'yyyy-MM-dd'))
    this.userForm.value.dateOfBirth = this.datePipe.transform(date, 'yyyy-MM-dd');
  }

  addResourceUser() {
    this.userForm.value.resource = {
      firstName: this.userForm.value.firstName,
      lastName: this.userForm.value.lastName,
      phoneNumber1: this.userForm.value.phoneNumber1,
      emailId: this.userForm.value.emailId,
      address: null,
      resourceType: this.userForm.value.resourceType,
      designation : this.userForm.value.designation,
      dateOfBirth: this.userForm.value.dateOfBirth,
      gender: this.userForm.value.gender,
      governmentIdNumber1: this.userForm.value.governmentIdNumber1,
      governmentIdType1: this.userForm.value.governmentIdType1,
      language: this.userForm.value.language,
    }

    delete this.userForm.value.firstName;
    delete this.userForm.value.lastName;
    delete this.userForm.value.phoneNumber1;
    delete this.userForm.value.emailId;
    delete this.userForm.value.resourceType;
    delete this.userForm.value.language;
    delete this.userForm.value.governmentIdType1;
    delete this.userForm.value.governmentIdNumber1;
    delete this.userForm.value.dateOfBirth;
    delete this.userForm.value.designation;
    delete this.userForm.value.gender;

    console.log(this.userForm.value);

    this.userService.addUserResurce(this.userForm.value).subscribe(res => {
      console.log(res);
      this.submitText = "Submit";
      this.openSnackBar("User added successfully");
      this.userForm.reset();
      this.router.navigateByUrl('/userandrole');
    }, Error => {
      console.log(Error);
      this.submitText = "Submit";
      this.openSnackBar("Error in adding user ! Please try again later");
      this.userForm.reset();
    })
  }
}
